import { SplitViewContext } from '../components/split_view';
import AddOneForm           from './one_form';
import KioskModeButton      from './kiosk_mode_button';
import Navbar               from '../components/navbar';
import React                from 'react';



export default function AddOnePage({ businessID, navigateTo }) {
  return (
    <React.Fragment>
      <Navbar title="Add Contact" backLink={`/${businessID}/contacts`}/>
      <div className="page-content">
        <AddOneForm {...{ businessID, navigateTo }}/>
        <SplitViewContext.Consumer>{
          isSplitView => (
            !isSplitView && (<KioskModeButton businessID={businessID}/>)
          )
        }
        </SplitViewContext.Consumer>
      </div>
    </React.Fragment>
  );
}
